import { Button, Card, Checkbox, DatePicker, Form, Input, Modal, Spin, Tag } from 'antd';
import React from "react";
import moment from "moment";

class Create extends React.Component {
  constructor() {
    super();
    this.state = {
      status: false,
      closureModalVisible: false,
      closureDate: moment(),
      pendingInvoiceModalVisible: false,
      pendingInvoiceDate: moment(),
    }
  }

  componentDidMount() {
    const { match, location, fetch, data } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
    if (data.status === 'Open') {
      let activitiesStatus = false;
      let item = data && data.activities;
      for (let i = 0; i < item.length; i++) {
        if (!item[i].status || item[i].status === 'Open') {
          activitiesStatus = false;
          break;
        }
        activitiesStatus = true;
      }
      this.setState({ status: activitiesStatus });
    } else {
      this.setState({ status: false });
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps && nextProps.data && nextProps.data.activities && JSON.stringify(nextProps.data.activities) !== JSON.stringify(this.props.data.activities)) {
      if (nextProps.data.status === 'Open') {
        let activitiesStatus = false;
        let item = nextProps.data.activities;
        for (let i = 0; i < item.length; i++) {
          if (!item[i].status || item[i].status === 'Open') {
            activitiesStatus = false;
            break;
          }
          activitiesStatus = true;
        }
        this.setState({ status: activitiesStatus });
      } else {
        this.setState({ status: false });
      }
    }
  }

  handleSubmit = (e) => {
    const { match, data, title } = this.props;
    this.setState({ status: false });
    e.preventDefault();
    const backToModule = this.props.location.search.split("=")[1];

    // Check if this is a "Close" action (when status is Open and we're in EDIT mode)
    if (title === 'EDIT' && data && data.status === 'Open') {

      if (data.statusTitle === 'ClosedPendingInvoice' && data.closurePendingInvoiceDate) {
        this.setState({
          closureModalVisible: false,
          closureDate: moment(data.closurePendingInvoiceDate)
        });
        this.submitForm(backToModule, match);
      } else {

        // Set initial closure date to max of current date and highest activity close date
        const highestActivityCloseDate = this.getHighestActivityCloseDate();
        const currentDate = moment();
        const initialClosureDate = highestActivityCloseDate && highestActivityCloseDate.isAfter(currentDate)
          ? highestActivityCloseDate
          : currentDate;

        // console.log('initialClosureDate', initialClosureDate);
        this.setState({
          closureModalVisible: true,
          closureDate: initialClosureDate
        });
        // Don't submit form here - wait for modal confirmation
      }
    } else {
      // For non-close actions, submit form immediately
      this.submitForm(backToModule, match);
    }
  }

  handlePendingInvoiceSubmit = (e, isReopen = false) => {
    e.preventDefault();
    const { data } = this.props;
    // console.log('isReopn ', isReopen)
    // return;

    if (!isReopen) {
      // Set initial pending invoice date to max of current date and job card created date
      const jobCardCreatedDate = data && data.createdAt ? moment(data.createdAt) : moment();
      const currentDate = moment();
      const initialPendingInvoiceDate = jobCardCreatedDate.isAfter(currentDate)
        ? jobCardCreatedDate
        : currentDate;

      this.setState({
        pendingInvoiceModalVisible: true,
        pendingInvoiceDate: initialPendingInvoiceDate
      });
    } else {
      const { match } = this.props;
      const backToModule = this.props.location.search.split("=")[1];
      this.setState({
        closureDate: null,
        pendingInvoiceDate: null,
      }, () => this.submitPendingInvoiceOpenForm(backToModule, match))
    }
  };

  submitForm = (backToModule, match) => {
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      if (this.state.closureDate) {
        values['closureDate'] = this.state.closureDate.toISOString();
        // console.log('values', values);
      }

      if (match.params && match.params.id) {
        if (backToModule === 'jobCard') {
          const urlBackToJobCard = `/job-card/report/${match.params.id}`;
          this.props.onSubmit(values, match.params.id, urlBackToJobCard);
        } else {
          this.props.onSubmit(values, match.params.id);
        }
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  submitPendingInvoiceForm = (backToModule, match) => {
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      values['closurePendingInvoiceDate'] = this.state.pendingInvoiceDate.toISOString();
      values['closedPendingInvoice'] = true;

      if (match.params && match.params.id) {
        if (backToModule === 'jobCard') {
          const urlBackToJobCard = `/job-card/report/${match.params.id}`;
          this.props.onSubmit(values, match.params.id, urlBackToJobCard);
        } else {
          this.props.onSubmit(values, match.params.id);
        }
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  submitPendingInvoiceOpenForm = (backToModule, match) => {
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      values['closurePendingInvoiceDate'] = null; //this.state.pendingInvoiceDate.toISOString();
      values['closedPendingInvoice'] = false;
      values['reopenPendingInvoice'] = true;
      values['closureDate'] = null;
      values['status'] = 'Open';
      values['statusTitle'] = null;

      if (match.params && match.params.id) {
        if (backToModule === 'jobCard') {
          const urlBackToJobCard = `/job-card/report/${match.params.id}`;
          this.props.onSubmit(values, match.params.id, urlBackToJobCard);
        } else {
          this.props.onSubmit(values, match.params.id);
        }
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  handleClosureDateChange = (date) => {
    this.setState({ closureDate: date });
  };

  getHighestActivityCloseDate = () => {
    const { data } = this.props;
    if (!data || !data.activities || data.activities.length === 0) {
      return null;
    }

    let highestCloseDate = null;

    const activities = (data && data.activitiesData && data.activitiesData.activities)
      || (data && data.activities) || []

    activities.forEach(activity => {
      // console.log('activity', activity);
      if (activity.status === 'Closed' && activity.closureDate) {
        const activityCloseDate = moment(activity.closureDate);
        if (!highestCloseDate || activityCloseDate.isAfter(highestCloseDate)) {
          highestCloseDate = activityCloseDate;
        }
      } else if (activity.status === 'Closed' && activity.autoJcCloseVoucher && activity.autoJcCloseVoucher.length) {
        const closedJC = activity.autoJcCloseVoucher[0];
        if (closedJC && closedJC.closingDate)
          highestCloseDate = moment(closedJC.closingDate)
      } else if (activity.status === 'Closed' && activity.updatedAt) {
        const activityOpenDate = moment(activity.updatedAt);
        if (!highestCloseDate || activityOpenDate.isAfter(highestCloseDate)) {
          highestCloseDate = activityOpenDate;
        }
      }
    });

    return highestCloseDate;
  };

  disabledDate = (current) => {
    const highestActivityCloseDate = this.getHighestActivityCloseDate();
    // console.log('highestActivityCloseDate', highestActivityCloseDate);
    if (highestActivityCloseDate) {
      // Disable dates before the highest activity close date
      return current && current.isBefore(highestActivityCloseDate, 'day');
    }

    // If no activities are closed, allow all dates
    return false;
  };

  handleClosureModalOk = () => {
    const { match } = this.props;
    const backToModule = this.props.location.search.split("=")[1];

    this.setState({ closureModalVisible: false });
    this.submitForm(backToModule, match);
  };

  handleClosureModalCancel = () => {
    this.setState({ closureModalVisible: false });
  };

  handlePendingInvoiceDateChange = (date) => {
    this.setState({ pendingInvoiceDate: date });
  };

  disabledPendingInvoiceDate = (current) => {
    const { data } = this.props;
    if (!data || !data.createdAt) {
      return false;
    }

    const jobCardCreatedDate = moment(data.createdAt);
    // Disable dates before the job card created date
    return current && current.isBefore(jobCardCreatedDate, 'day');
  };

  handlePendingInvoiceModalOk = () => {
    const { match } = this.props;
    const backToModule = this.props.location.search.split("=")[1];

    this.setState({ pendingInvoiceModalVisible: false });
    this.submitPendingInvoiceForm(backToModule, match);
  };

  handlePendingInvoiceModalCancel = () => {
    this.setState({ pendingInvoiceModalVisible: false });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data, loading, filters, title, resource, form } = this.props;
    const { status } = this.state;
    const activities = data.activities;
    let conditionForDisabledButton = '';
    let conditionForPendingInvoiceButton = true;

    activities && activities.length > 0 && activities.map((item) => {
      if (item.status === 'Open') {
        conditionForDisabledButton = true;
      }
    });

    activities && activities.length > 0 && activities.map((item) => {
      if (item.status === 'Open') {
        conditionForPendingInvoiceButton = false;
      }
    });

    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '20px',
      borderRadius: '9px',
    };

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={<div>Job Card Number - {data && data.jobCardNo}</div>}>
          {
            activities && activities.length ? <Form onSubmit={this.handleSubmit} layout="vertical">
              <div key={'status'} >
                <Form.Item key={`status0`} style={{ display: 'none' }} >
                  {getFieldDecorator(`status`, {
                    rules: [{ required: true, message: `Reason for Change In Date is required!` }],
                    initialValue: 'Closed',
                  })(<Input disabled />)
                  }
                </Form.Item>

                {
                  activities && activities.map((item) => {
                    return <div key={item._id} style={{
                      display: 'flex', justifyContent: 'space-between', marginTop: '10px',
                      border: '1px dashed #000',
                      padding: '20px',
                      marginBottom: '10px',
                      borderRadius: '9px'
                    }}>
                      <div>
                        <div>Activity Serial No - {item.activitySerialNo}</div>
                        <div>Activity Type Name - {item.activityType && item.activityType.name}</div>
                        <div>Description - {item.description}</div>
                        <div>Time Estimate - {item.timeEstimateInHour} Hour</div>
                        <div>Created At - {moment(item.createdAt).format('DD-MM-YYYY')} </div>
                      </div>
                      <div>{item.status === 'Open' ? <Tag color="magenta">{item.status}</Tag> : <Tag color="green">Closed</Tag>}</div>
                    </div>
                  })
                }

                {Object.keys(filters).map((item) => {
                  const dataKey = item.split('.')[1] ? item.split('.')[1] : item;
                  const dataKeyObj = item.split('.')[1] ? item.split('.')[0] : null;

                  const value = data && data[dataKeyObj ? dataKeyObj : item] ? (dataKeyObj ? data[dataKeyObj][dataKey] : data[dataKey]) : null;
                  if (filters[item].type === 'Boolean') {
                    return <Form.Item key={'followUp'} label={'Follow Up'}>
                      {getFieldDecorator('followUp', {
                        rules: [{ required: false, message: `Follow Up is required!` }],
                        valuePropName: 'checked',
                        initialValue: value,
                      })(<Checkbox></Checkbox>)}
                    </Form.Item>
                  }

                  if (filters[item].field === 'followUpDate' && form.getFieldValue('followUp')) {
                    return <Form.Item key={'followUpDate'} label={'Follow Up Date'}>
                      {getFieldDecorator('followUpDate', {
                        rules: [{ required: true, message: `followUpDate is required!` }],
                        initialValue: data && data.followUpDate && moment(data.followUpDate),
                      })(<DatePicker
                        disabled={(title === 'EDIT' && filters['followUpDate'] && filters['followUpDate'].options.disabledOnEdit) || false} />)
                      }
                    </Form.Item>
                  }
                })
                }
              </div>

              <Form.Item>
                <Button type="primary"
                  className="gx-mb-0 gx-mt-4"
                  htmlType="submit"
                  loading={loading}
                  disabled={this.props.title === 'EDIT' && conditionForDisabledButton}
                >
                  {/*{this.props.title === 'EDIT' ? ((data && data.status === 'Closed') ? 'CLOSED' : 'MARK AS CLOSED') : 'CREATE'}*/}
                  {this.props.title === 'EDIT' ? ((data && data.status === 'Closed') ? 'OPEN' : ((data && data.status === 'Open') ? 'CLOSE' : 'MARK AS OPEN')) : 'CREATE'}
                </Button>
              </Form.Item>

              {this.props.title === 'EDIT' && data && data.status === 'Open' && (
                <Form.Item>
                  <Button
                    type="danger"
                    className="gx-mb-0 gx-mt-0"
                    onClick={(e) => this.handlePendingInvoiceSubmit(e, false)}
                    loading={loading}
                    disabled={conditionForPendingInvoiceButton || data.statusTitle === 'ClosedPendingInvoice'}
                  >
                    Closed Pending Invoice
                  </Button>
                </Form.Item>
              )}
              {(data && data.statusTitle && data.statusTitle === 'ClosedPendingInvoice') ?
                <span>
                  <p>Closed Pending Invoice with date {moment(data.closurePendingInvoiceDate).format('DD-MM-YYYY')}</p>
                  <Button
                    type="danger"
                    className="gx-mb-0 gx-mt-0"
                    onClick={(e) => this.handlePendingInvoiceSubmit(e, true)}
                    loading={loading}
                  // disabled={conditionForPendingInvoiceButton || data.statusTitle === 'ClosedPendingInvoice'}
                  >
                    Reopen Pending Invoice
                  </Button>
                </span> : ''
              }
            </Form> : 'No Activities'
          }

          <Modal
            title="Select Closure Date"
            visible={this.state.closureModalVisible}
            onOk={this.handleClosureModalOk}
            onCancel={this.handleClosureModalCancel}
            okText="Confirm"
            cancelText="Cancel"
          >
            <Form.Item label="Closure Date">
              <DatePicker
                value={this.state.closureDate}
                onChange={this.handleClosureDateChange}
                disabledDate={this.disabledDate}
                format="YYYY-MM-DD"
                style={{ width: '100%' }}
              />
            </Form.Item>
            {this.getHighestActivityCloseDate() && (
              <div style={{ marginTop: '8px', color: '#666', fontSize: '12px' }}>
                Note: Closure date must be on or after {this.getHighestActivityCloseDate().format('DD-MM-YYYY')} (latest activity close date)
              </div>
            )}
          </Modal>

          <Modal
            title="Select Closure Date for Pending Invoice"
            visible={this.state.pendingInvoiceModalVisible}
            onOk={this.handlePendingInvoiceModalOk}
            onCancel={this.handlePendingInvoiceModalCancel}
            okText="Confirm"
            cancelText="Cancel"
          >
            <Form.Item label="Closure Date">
              <DatePicker
                value={this.state.pendingInvoiceDate}
                onChange={this.handlePendingInvoiceDateChange}
                disabledDate={this.disabledPendingInvoiceDate}
                format="YYYY-MM-DD"
                style={{ width: '100%' }}
              />
            </Form.Item>
            {data && data.createdAt && (
              <div style={{ marginTop: '8px', color: '#666', fontSize: '12px' }}>
                Note: Closure date must be on or after {moment(data.createdAt).format('DD-MM-YYYY')} (job card created date)
              </div>
            )}
          </Modal>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;


